import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from "gatsby-theme-vlog/src/components/layout";
import { Styled } from 'theme-ui';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Layout mdxType="Layout">
    <Styled.h1>Oh, hello world!</Styled.h1>
    <iframe title="Gatsby for Agencies and Teams" src="https://www.youtube.com/embed/jRntYO4186Y"></iframe>
    <iframe title="Space Jam Theme Song" src="https://www.youtube.com/embed/J9FImc2LOr8"></iframe>
    <iframe title="How to Make Strawberry Jam" src="https://www.youtube.com/embed/4gql2HygmfU"></iframe>
    <iframe title="State of the JAMstack Nation" src="https://www.youtube.com/embed/COAVmST41Q0"></iframe>
    <iframe title="Build modern JAMstack Websites in Minutes" src="https://www.youtube.com/embed/AHZjqYFfzyk"></iframe>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      